import { render, staticRenderFns } from "./JobsTreeOrganizations.vue?vue&type=template&id=2059966e"
import script from "./JobsTreeOrganizations.vue?vue&type=script&lang=js"
export * from "./JobsTreeOrganizations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports